import { useMemo } from 'react'

import {
  WorkplacesLocationsSelectorDocument,
  type WorkplacesLocationsSelectorQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface WorkplaceOption {
  label: string
  value: number
}

export const useWorkplaces = (): {
  workplaces: WorkplaceOption[]
  loading: boolean
  error?: unknown
} => {
  const { data, loading, error } = useQuery<
    WorkplacesLocationsSelectorQuery,
    Record<string, never>
  >(WorkplacesLocationsSelectorDocument, {
    fetchPolicy: 'cache-and-network',
  })

  const nodes = useMemo<
    NonNullable<WorkplacesLocationsSelectorQuery['locations']>['locationsConnection']['nodes']
  >(
    () => data?.locations?.locationsConnection?.nodes ?? [],
    [data?.locations?.locationsConnection?.nodes]
  )

  const workplaces = useMemo<WorkplaceOption[]>(() => {
    return nodes
      .filter((node): node is NonNullable<(typeof nodes)[number]> => Boolean(node))
      .map((node) => ({
        label: node.name ?? '',
        value: Number(node.id),
      }))
  }, [nodes])

  return { workplaces, loading, error }
}
